import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { SelfAssessmentTemplate3Service } from 'src/app/core/services/self-assessment-template3/self-assessment-template3.service';
import { SignalRService } from 'src/app/core/services/signalR/signal-r.service';
import { ModalDialogComponent } from '../../distributed-ui-components/modal-dialog/modal-dialog.component';
import { UserProfile } from 'src/app/core/models/user';
import { revisionHistoryAccessTypeEnum } from 'src/app/core/models/ckEditor/revisionData';
import { SelfAssessmentT3ApproachDto } from 'src/app/core/models/self-assessmentT3/SelfAssessmentApproach';
import { SelfAssessmentDocumentModel } from 'src/app/core/models/self-assessment/self-assessment-document-model';
import { overallAssessmentDropdownList } from 'src/app/core/models/self-assessmentT3/overallDropdownList';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { VersionHistoryT3DataDto } from 'src/app/core/models/self-assessmentT3/version-filter-viewT3-model';
import { breadCrumbsList } from 'src/app/core/models/breadCrumbs/breadCrumbs';
import { cloneDeep } from 'lodash';
import { GlobalService } from 'src/app/core/services/global/global.service';

@Component({
  selector: 'app-approach-t3',
  templateUrl: './approach-t3.component.html',
  styleUrls: ['./approach-t3.component.scss'],
})
export class ApproachT3Component implements OnInit {
  @Input() summaryDetailsId!: string;
  summaryId: number = 0;
  tabs: string[] = [];
  isLoader: boolean = true;
  user: UserProfile = new UserProfile();
  numberOfApproaches: number = 1;
  accessType: revisionHistoryAccessTypeEnum | undefined;
  selfAssessmentId: number;
  active: number = 0;
  tab: number = 0;
  approachList: SelfAssessmentT3ApproachDto = new SelfAssessmentT3ApproachDto();
  previousApproachList : SelfAssessmentT3ApproachDto = new SelfAssessmentT3ApproachDto();
  selfAssessmentDocument: SelfAssessmentDocumentModel[] = [];
  approachAssessmentDropdownList: overallAssessmentDropdownList =
    new overallAssessmentDropdownList();
  isToastShow = false;
  toastModel: ToastViewModel = new ToastViewModel();
  breadCampsList: breadCrumbsList[] = [];

  constructor(
    private _sessionService: SessionService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private _selfAssessmentT3Service: SelfAssessmentTemplate3Service,
    private ref: ChangeDetectorRef,
    private _signalRService: SignalRService,
    @Inject(MAT_DIALOG_DATA)
    public versionHistoryData: VersionHistoryT3DataDto,
    private _globalService: GlobalService
  ) {
    this.numberOfApproaches = 1;
    this.accessType = revisionHistoryAccessTypeEnum.All;
    this.selfAssessmentId = 0;
    this.breadCampsList = [{ "name": "Assessment", "className": 'active' }, { "name": "Review", "className": "" }, { "name": "Approval", "className": "" }, { "name": "Approved", "className": "" }];
  }
  ngOnInit() {
    if (this.versionHistoryData && this.versionHistoryData.isVersonHistory) {
      this.fetchApproachVersionHistoryData(
        this.versionHistoryData.overAssessmentId
      );
      this.tab = this.versionHistoryData.tab;
    } else {
      if (!this.summaryDetailsId) {
        this.route.params.subscribe((params: any) => {
          this.summaryDetailsId = params['id'];
          this.summaryId = parseInt(this.summaryDetailsId);
        });
      }
      this.addApproach();
      this.getAllApproachData();
    }
    this.getUserDetails();
    this.getOverallAssessmentAllDropDowns();
  }
  fetchApproachVersionHistoryData(id: number) {
    this._selfAssessmentT3Service
      .getApproachVersionHistoryDetails(id)
      .subscribe((data: any) => {
        this.approachList = data;
        this.approachList.id = data.approachesId;
        if (this.approachList.id > 0) {
          this.getAssessmentDocuments();
        }
        if (
          this.approachAssessmentDropdownList.actionClosedList &&
          this.approachAssessmentDropdownList.actionClosedList.length > 0 &&
          this.approachList.id > 0 &&
          this.selfAssessmentDocument &&
          this.user.fullName != ''
        ) {
          this.isLoader = false;
        }
        //this.previousApproachList = cloneDeep(this.approachList);
      });
  }
  getUserDetails() {
    this._sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
      this.user = user;
      if (
        this.approachAssessmentDropdownList.actionClosedList &&
        this.approachAssessmentDropdownList.actionClosedList.length > 0 &&
        this.approachList.id > 0 &&
        this.selfAssessmentDocument &&
        this.user.fullName != ''
      ) {
        this.isLoader = false;
      }
    });
  }
  addApproach() {
    let i = this.numberOfApproaches.toString();
    this.tabs.push(i);
    this.numberOfApproaches++;
    this.tabs;
  }
  addAdditonalApproach() {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      data: {
        message: 'Are you sure want to add a new Approach?',
        title: 'Add New Approach',
        btnText: 'Ok',
      },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this._selfAssessmentT3Service
          .addAdditionalApproach(parseInt(this.summaryDetailsId))
          .subscribe((result: any) => {
            this.getAllApproachData();
          });
      }
    });
  }
  getAllApproachData() {
    this._selfAssessmentT3Service
      .getAllApproachAssessmentById(parseInt(this.summaryDetailsId))
      .subscribe((data: any) => {
        this.tabs = data;
        this.defaultOpen();
      });
  }
  defaultOpen() {
    if (this.tabs.length != 0) {
      this.setTab(parseInt(this.tabs[0]), 0);
    }
  }
  setTab(id: number, index: number) {
    this._globalService.selectedSubmitterName = '';
    this._globalService.selectedReviewerName = [];
    this._globalService.selectedApproverName = [];
    this._globalService.selectedCondApproverName = [];
    this.active = index;
    this.isLoader = true;
    this.tab = index + 1;
    this.getApproachesData(id);
  }
  getApproachesData(id: number) {
    this._selfAssessmentT3Service.getT3Approaches(id).subscribe((data: any) => {
      this.approachList = data;
      if (this.approachList.id > 0) {
        this.getAssessmentDocuments();
      }
      if (
        this.approachAssessmentDropdownList.actionClosedList &&
        this.approachAssessmentDropdownList.actionClosedList.length > 0 &&
        this.approachList.id > 0 &&
        this.selfAssessmentDocument &&
        this.user.fullName != ''
      ) {
        this.isLoader = false;
      }
      this.breadCrumbsSet();
      this.previousApproachList = cloneDeep(this.approachList); 
    });
  }
  getAssessmentDocuments() {
    this._selfAssessmentT3Service
      .getSelfAssessmentT3ApproachDocument(this.approachList.id)
      .subscribe((result: SelfAssessmentDocumentModel[]) => {
        this.selfAssessmentDocument = result;
        if (
          this.approachAssessmentDropdownList.actionClosedList &&
          this.approachAssessmentDropdownList.actionClosedList.length > 0 &&
          this.approachList.id > 0 &&
          this.selfAssessmentDocument &&
          this.user.fullName != ''
        ) {
          this.isLoader = false;
        }
      });
  }
  getOverallAssessmentAllDropDowns() {
    this._selfAssessmentT3Service
      .getT3InterpretationAssessmentDropdowns()
      .subscribe((res: overallAssessmentDropdownList) => {
        this.approachAssessmentDropdownList = res;
        if (
          this.approachAssessmentDropdownList.actionClosedList &&
          this.approachAssessmentDropdownList.actionClosedList.length > 0 &&
          this.approachList.id > 0 &&
          this.selfAssessmentDocument &&
          this.user.fullName != ''
        ) {
          this.isLoader = false;
        }
      });
  }
  saveApproachData() {
    this._selfAssessmentT3Service
      .saveApproachDataT3(this.approachList)
      .subscribe((x) => {
        this.alertMessage('success', 'Approach saved successfully');
        setTimeout(() => {}, 3500);
      });
  }
  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3500);
  }
  @Output() notifyCkEditorChange: EventEmitter<any> = new EventEmitter<any>();
  notifyDetailsComponentCkEditorChange() {
    this.notifyCkEditorChange.emit();
  }
  async isReadyForReviewChanged(checked: boolean) {
    if(checked){
      this.changeBreadCrumbs("Review");
    }
    else{
      this.changeBreadCrumbs("Assessment");
    }
  }

  isReadyForApprovalChanged(checked:boolean) {
    if(checked){
      this.changeBreadCrumbs("Approval");
    }
    else{
      this.changeBreadCrumbs("Review");
    }
  }

  isReadyForConditionalApprovalChanged(checked:boolean) {
    if(checked){
      this.changeBreadCrumbs("Approved");
    }
    else{
      this.changeBreadCrumbs("Approval");
    }
  }

  changeBreadCrumbs(item: string) {
    if (this.breadCampsList) {
      // Use map to set className to "" for all items
      this.breadCampsList = this.breadCampsList.map(item => {
        return { ...item, className: "" };
      });
      const index = this.breadCampsList.findIndex(ob => ob.name === item);
      if (index !== -1) {
        //this.breadCampsList[reviewIndex].className = 'active'; // Set new class name for the 'Review' item
        this.breadCampsList = [
          ...this.breadCampsList.slice(0, index + 1).map(item => ({ ...item, className: 'active' })),
          ...this.breadCampsList.slice(index + 1)
        ];
      }
    }
  }

  breadCrumbsSet() {
    if (this.approachList.conditionalApproval == true) {
      this.changeBreadCrumbs("Approved");
    }
    else if (this.approachList.readyForApproval == true) {
      this.changeBreadCrumbs("Approval");
    }
    else if (this.approachList.readyForReview == true) {
      this.changeBreadCrumbs("Review");
    }
    else {
      this.changeBreadCrumbs("Assessment");
    }
  }
  isDataChange:boolean=false;
  performLeaveCheck(): boolean {
    const currentDataStr = JSON.stringify(this.approachList);
    const previousDataStr = JSON.stringify(this.previousApproachList);
    if (currentDataStr !== previousDataStr) {
      this.isDataChange=true;
      // Perform actions based on changes
    } else {
      this.isDataChange=false;
    }
    return this.isDataChange;
  }
}
